/**
 * Trip Creation Step IDs
 *
 * Unique identifiers for each step in the trip creation flow.
 */
export const TRIP_CREATION_STEP_IDS = Object.freeze({
  tripConditions: 'trip-conditions',
  tripDetails: 'trip-details',
  customAdditionalInfo: 'custom-additional-info',
  recurringSchedule: 'recurring-schedule',
  summary: 'summary',
});

/**
 * Trip Creation Steps
 *
 * Configuration for each step in the trip creation flow, including:
 * - id: unique step identifier
 * - label: displayed name of the step
 * - disabledStepTooltipTitle: optional tooltip if the step is disabled
 */
export const TRIP_CREATION_STEPS = Object.freeze([
  { id: TRIP_CREATION_STEP_IDS.tripConditions, label: 'Trip Conditions' },
  { id: TRIP_CREATION_STEP_IDS.tripDetails, label: 'Trip Details' },
  {
    id: TRIP_CREATION_STEP_IDS.customAdditionalInfo,
    label: 'Custom Info',
  },
  {
    id: TRIP_CREATION_STEP_IDS.recurringSchedule,
    label: 'Recurring Schedule',
    disabledStepTooltipTitle:
      'Recurrence is not available for the selected trip type',
  },
  { id: TRIP_CREATION_STEP_IDS.summary, label: 'Summary' },
]);

/**
 * Duplicate Trip Creation Steps
 *
 * Steps used specifically when duplicating an existing trip.
 * Typically a subset of the full trip creation steps.
 *
 * Each step object contains:
 * - id: unique step identifier
 * - label: displayed name of the step
 */
export const DUPLICATE_TRIP_CREATION_STEPS = Object.freeze([
  { id: TRIP_CREATION_STEP_IDS.tripConditions, label: 'Trip Conditions' },
  {
    id: TRIP_CREATION_STEP_IDS.recurringSchedule,
    label: 'Recurring Schedule',
  },
]);
